export const wizardModeQueryParam = "mode";
